import { WttpTemplateQuestionnaire } from 'src/graphql/generated/graphql';
import { QuestionnairesSchedule } from 'src/components/wttp/templates/form/questionnaires-list/table';

export const prepareWttpTemplateFormQuestionnaires = (
  questionnairesWithSchedules?:
    | Pick<WttpTemplateQuestionnaire, 'id' | 'questionnaireId' | 'scheduleId'>[]
    | null,
) => {
  return (
    questionnairesWithSchedules?.map((questionnaireWithSchedule) => ({
      questionnaireId: questionnaireWithSchedule.questionnaireId,
      scheduleId: questionnaireWithSchedule.scheduleId,
    })) || []
  );
};

export const validateWttpTemplateFormQuestionnaires = (
  value: Array<QuestionnairesSchedule>,
  { setError, t }: { setError: any; t: any },
) => {
  if (!value?.length) {
    setError('questionnaires', {
      message: t('wttp.template.form.error.questionnaires-required'),
    });
    return false;
  }

  const hasInvalid = value.some((item) => !item.scheduleId);
  if (hasInvalid) {
    setError('questionnaires', {
      message: t('wttp.template.form.error.questionnaires-schedule-required'),
    });
    return false;
  }

  return true;
};
